import { render, staticRenderFns } from "./bulk-update-error-drawer.vue?vue&type=template&id=cb12201c&"
import script from "./bulk-update-error-drawer.vue?vue&type=script&lang=js&"
export * from "./bulk-update-error-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports